import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, CheckCircle2 } from 'lucide-react';
const tomos = [{
  num: '1',
  emoji: '📘',
  title: 'Fundamentos y Test de Campo',
  desc: 'Establecé tu Punto Cero sin tecnología cara. Adiós kilómetros basura.'
}, {
  num: '2',
  emoji: '📙',
  title: 'La Ciencia de la Micro-Sobrecarga',
  desc: 'Los 4 Pilares y las sesiones escritas día por día para transformar tu potencia.'
}, {
  num: '3',
  emoji: '📗',
  title: 'Nutrición de Supermercado',
  desc: 'Geles, isotónicos y barras caseras al 5% del costo de los importados.'
}, {
  num: '4',
  emoji: '📕',
  title: 'El Calendario de 12 Semanas',
  desc: 'Qué hacer cada día: carga, descarga, retest y plan de contingencia.'
}, {
  num: '5',
  emoji: '📒',
  title: 'Mecánica y Biomecánica DIY',
  desc: '5 tests caseros para tu posición perfecta + mantenimiento en 15 min.'
}, {
  num: '6',
  emoji: '📓',
  title: 'Mentalidad de Pelotón y Cierre',
  desc: 'Tácticas de viento, lectura de pelotón y gestión del sufrimiento.'
}];
export function TomosSection() {
  return <section className="py-10 md:py-14 px-4 bg-slate-950" data-id="element-361">
      <div className="max-w-3xl mx-auto" data-id="element-362">
        <div className="space-y-6 mb-10" data-id="element-363">
          {tomos.map((tomo, index) => <FadeIn key={tomo.num} delay={index * 0.1} data-id="element-364">
              <div className="bg-slate-900 border border-slate-800 border-l-4 border-l-amber-500 rounded-r-xl p-6 md:p-8 shadow-md" data-id="element-365">
                <h3 className="text-lg md:text-xl mb-3 leading-snug" data-id="element-366">
                  <span className="mr-2" data-id="element-367">{tomo.emoji}</span>
                  <span className="text-amber-500 font-bold" data-id="element-368">
                    TOMO {tomo.num} —{' '}
                  </span>
                  <span className="text-white font-bold" data-id="element-369">{tomo.title}</span>
                </h3>
                <p className="text-slate-400 leading-relaxed text-base md:text-lg" data-id="element-370">
                  {tomo.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-371">
          <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8" data-id="element-372">
            <h3 className="text-xl font-bold text-white mb-6 text-center" data-id="element-373">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-374">
              {['Protocolos listos para aplicar', 'Calendarios y tablas imprimibles', 'Checklists de verificación', 'Plantillas A4 para usar desde el día 1'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-375">
                  <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-376" />
                  <span className="text-slate-300" data-id="element-377">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}